<template>
  <div class="media-displayer-single-gallery">
    <component 
      :is="displayTypeComponent" 
      :gallery="gallery" 
      @openGallery="$emit('openGallery', $event)"
    />
  </div>
</template>

<script>
import { GalleryDisplayType } from '../constants/galleryDisplayType'
import HorizontalGallery from '../displayType/Horizontal'
import VerticalGallery from '../displayType/Vertical'
import CompactThumbGallery from '../displayType/CompactThumb'
import CompactHorizontalGallery from '../displayType/CompactHorizontal'
import ReelGallery from '../displayType/Reel'
import ContainerGallery from '../displayType/Container'

export default {
  name: 'MediaDisplayerSingleGallery',

  components: {
    HorizontalGallery,
    VerticalGallery,
    CompactThumbGallery,
    CompactHorizontalGallery,
    ReelGallery,
    ContainerGallery
  },

  props: {
    gallery: {
      type: Object,
      required: true
    }
  },

  computed: {
    displayTypeComponent() {
      if (!this.gallery || !this.gallery.display_type) {
        return 'VerticalGallery'
      }
      switch (this.gallery.display_type) {
        case GalleryDisplayType.HORIZONTAL.value:
          return 'HorizontalGallery'
        case GalleryDisplayType.VERTICAL.value:
          return 'VerticalGallery'
        case GalleryDisplayType.COMPACT_THUMB.value:
          if (this.gallery.sub_gallery && this.gallery.sub_gallery.length > 0)
            return 'CompactThumbGallery'
          else
            return 'VerticalGallery'
        case GalleryDisplayType.COMPACT_HORIZONTAL.value:
          if (this.gallery.sub_gallery && this.gallery.sub_gallery.length > 0)
            return 'CompactHorizontalGallery'
          else
            return 'HorizontalGallery'
        case GalleryDisplayType.REEL.value:
          return 'ReelGallery'
        case GalleryDisplayType.CONTAINER.value:
          return 'ContainerGallery'
        default:
          return 'VerticalGallery'
      }
    }
  }
}
</script>

<style scoped>
.media-displayer-single-gallery {
  margin-bottom: 2rem;
}
</style>